import React, { Component } from 'react';
import { connect } from 'react-redux';

import CoverImage from '../../components/CoverImage';
import CityButton from '../../components/CityButton';
import AudioPlayer from '../../components/AudioPlayer';

import { changeCity, pauseSound } from '../../modules/app';

class MainApp extends Component {
    componentWillReceiveProps(nextProps) {
        const { match, dispatch } = nextProps;

        if ('city' in match.params) {
            if (this.props.match.params.city !== match.params.city) {
                dispatch(changeCity(match.params.city));
            }
        }

        // Always stop previously played sound
        dispatch(pauseSound());
    }

    componentWillMount() {
        const { match, dispatch, cities, selectedCity } = this.props;

        if ('city' in match.params) {
            dispatch(changeCity(match.params.city));
        } else {
            if (selectedCity === undefined) {
                const firstCity = Object.keys(cities)[0];
                dispatch(changeCity(firstCity));
            }
        }

        // Always stop previously played sound
        dispatch(pauseSound());
        console.log('componentWillMount');
    }

    onCityClicked(name) {
        this.props.dispatch(changeCity(name));
    }

    renderCityList() {
        const { cities, selectedCity } = this.props;

        return Object.keys(cities).map(name => {
            return (
                <CityButton
                    key={name}
                    data={cities[name]}
                    link={`/${name}`}
                    isActive={name === selectedCity}
                />
            )
        });
    }

    render() {
        const { selectedCity, cities } = this.props;
        let selectedData = cities[selectedCity];
        
        if (typeof selectedData === 'undefined') {
            return null;
        }

        return (
            <div>
                <CoverImage data={selectedData}>
                    <AudioPlayer data={selectedData} />
                </CoverImage>

                <div className="city-list">
                    {this.renderCityList()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { selectedCity, cities } = state.app;
    return { selectedCity, cities }
};

export default connect(mapStateToProps)(MainApp);



// WEBPACK FOOTER //
// ./src/containers/App/main.js